import {Directive, TemplateRef} from '@angular/core';

@Directive({ selector: '[storeverDatatableDetailsTemplate]' })
export class DataTableDetailsTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
